import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Typography } from '@material-ui/core';
import classnames from 'classnames';
import { IconButton, Icon } from 'components';
import styles from './Preview.scss';

const Content = ({ assistiveText }) =>
    <div className={styles.content}>
        <Typography variant='h6' className={styles.title}>
            { assistiveText.title }
        </Typography>
        <Typography variant='body1' className={styles.description}>
            { assistiveText.description }
        </Typography>
    </div>;

const Preview = ({ assistiveText, className }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Tooltip
            open={isOpen}
            onClose={() => setIsOpen(false)}
            onOpen={() => setIsOpen(true)}
            interactive
            PopperProps={{ className: styles.toolTip }}
            title={<Content assistiveText={assistiveText} />}
            placement='bottom-end'
        >
            <IconButton
                className={classnames(styles.trigger, className, { [styles.isOpen]: isOpen })}
            >
                <Icon name='ion-md-information' size='small' />
            </IconButton>
        </Tooltip>
        
    )
}

Preview.propTypes = {
    assistiveText: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string
    }),
    className: PropTypes.string
}

Preview.defaultProps = {
    assistiveText: { title: '', description: '' },
    className: ''
}

export default Preview
